import React, { useState, useEffect } from 'react';
import axios from 'axios';

import ResultTile from '../result/ResultTile';

function AllAPIsForm() {
  const [inputs, setInputs] = useState({
    brand_name: '',
    celebrity_name: '',
    collab_details: '',
    date: ''
  });
  const [isLoadingOne, setIsLoadingOne] = useState(false);
  const [isLoadingTwo, setIsLoadingTwo] = useState(false);
  const [isLoadingThree, setIsLoadingThree] = useState(false);
  const [isLoadingFour, setIsLoadingFour] = useState(false);
  const [isLoadingFive, setIsLoadingFive] = useState(false);
  const [isLoadingSix, setIsLoadingSix] = useState(false);
  const [resultsOne, setResultsOne] = useState([]);
  const [resultsTwo, setResultsTwo] = useState([]);
  const [resultsThree, setResultsThree] = useState([]);
  const [resultsFour, setResultsFour] = useState([]);
  const [resultsFive, setResultsFive] = useState([]);
  const [resultsSix, setResultsSix] = useState([]);
  const [errorMessageOne, setErrorMessageOne] = useState('');
  const [errorMessageTwo, setErrorMessageTwo] = useState('');
  const [errorMessageThree, setErrorMessageThree] = useState('');
  const [errorMessageFour, setErrorMessageFour] = useState('');
  const [errorMessageFive, setErrorMessageFive] = useState('');
  const [errorMessageSix, setErrorMessageSix] = useState('');
  const [apiEndpoints, setApiEndpoints] = useState({});

  // This function returns today's date in YYYY-MM-DD format
  const formatDate = (date) => {
    return date.toISOString().substring(0, 10);
  };

  // Fetch API endpoints
  useEffect(() => {
    const fetchApiEndpoints = async () => {
      try {
        const res = await axios.get('/wp-json/custom/v1/options');
        console.log('Fetched API endpoints:', res.data);
        setApiEndpoints(res.data);
      } catch (error) {
        console.error('Error fetching API endpoints:', error);
      }
    };

    fetchApiEndpoints();
  }, []);

  // api calls
  const handleAPIone = async () => {
    const dataToSend = {
      brand_name: inputs.brand_name,
      celebrity_name: inputs.celebrity_name,
      collab_details: inputs.collab_details,
      regenerate: 0
    };

    setIsLoadingOne(true);
    console.log('Sending API 1 data:', dataToSend);
    setResultsOne([]);
    setErrorMessageOne('');
    try {
      const res = await axios.post(
        '/wp-json/custom/v1/proxy',
        {
          url: apiEndpoints.fuselight_api_1_testing,
          data: dataToSend
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      console.log('Received API one data:', res.data);
      setResultsOne(res.data);
    } catch (error) {
      console.error('Error fetching API one data:', error);
      const message =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : 'Failed to fetch data. Please try again later.';
      setErrorMessageOne(`Error: ${message}`);
    } finally {
      setIsLoadingOne(false);
    }
  };

  const handleAPItwo = async () => {
    const dataToSend = {
      input_date: inputs.date,
      input_name: inputs.brand_name
    };

    setIsLoadingTwo(true);
    console.log('Sending API 2a data:', dataToSend);
    setResultsTwo([]);
    setErrorMessageTwo('');
    try {
      const res = await axios.post(
        '/wp-json/custom/v1/proxy',
        {
          url: apiEndpoints.fuselight_api_2a_testing,
          data: dataToSend
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      console.log('Received API 2a data:', res.data);
      setResultsTwo(res.data);
    } catch (error) {
      console.error('Error fetching API 2a data:', error);
      const message =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : 'Failed to fetch data. Please try again later.';
      setErrorMessageTwo(`Error: ${message}`);
    } finally {
      setIsLoadingTwo(false);
    }
  };

  const handleAPIthree = async () => {
    const dataToSend = {
      input_date: inputs.date,
      input_name: inputs.celebrity_name
    };

    setIsLoadingThree(true);
    console.log('Sending API 2b data:', dataToSend);
    setResultsThree([]);
    setErrorMessageThree('');
    try {
      const res = await axios.post(
        '/wp-json/custom/v1/proxy',
        {
          url: apiEndpoints.fuselight_api_2b_testing,
          data: dataToSend
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      console.log('Received API 2b data:', res.data);
      setResultsThree(res.data);
    } catch (error) {
      console.error('Error fetching data:', error);
      const message =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : 'Failed to fetch data. Please try again later.';
      setErrorMessageThree(`Error: ${message}`);
    } finally {
      setIsLoadingThree(false);
    }
  };

  const handleAPIfour = async () => {
    const dataToSend = {
      brand_name: inputs.brand_name,
      date: inputs.date
    };

    setIsLoadingFour(true);
    console.log('Sending API 3 data:', dataToSend);
    setResultsFour([]);
    setErrorMessageFour('');
    try {
      const res = await axios.post(
        '/wp-json/custom/v1/proxy',
        {
          url: apiEndpoints.fuselight_api_3_testing,
          data: dataToSend
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      console.log('Received API 3 data:', res.data);
      setResultsFour(res.data);
    } catch (error) {
      console.error('Error fetching data:', error);
      const message =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : 'Failed to fetch data. Please try again later.';
      setErrorMessageFour(`Error: ${message}`);
    } finally {
      setIsLoadingFour(false);
    }
  };

  const handleAPIfive = async () => {
    const dataToSend = {
      date: inputs.date,
      brand_name: inputs.brand_name,
      celebrity_name: inputs.celebrity_name
    };

    setIsLoadingFive(true);
    console.log('Sending API 4 data:', dataToSend);
    setResultsFive([]);
    setErrorMessageFive('');
    try {
      const res = await axios.post(
        '/wp-json/custom/v1/proxy',
        {
          url: apiEndpoints.fuselight_api_4_testing,
          data: dataToSend
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      console.log('Received API 4 data:', res.data);
      setResultsFive(res.data);
    } catch (error) {
      console.error('Error fetching data:', error);
      const message =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : 'Failed to fetch data. Please try again later.';
      setErrorMessageFive(`Error: ${message}`);
    } finally {
      setIsLoadingFive(false);
    }
  };

  const handleAPISix = async () => {
    const dataToSend = {
      brand_name: inputs.brand_name,
      celebrity_name: inputs.celebrity_name
    };

    setIsLoadingSix(true);
    console.log('Sending API 5 data:', dataToSend);
    setResultsSix([]);
    setErrorMessageSix('');
    try {
      const res = await axios.post(
        '/wp-json/custom/v1/proxy',
        {
          url: apiEndpoints.fuselight_api_5_testing,
          data: dataToSend
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      console.log('Received API 5 data:', res.data);
      setResultsSix(res.data);
    } catch (error) {
      console.error('Error fetching data:', error);
      const message =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : 'Failed to fetch data. Please try again later.';
      setErrorMessageSix(`Error: ${message}`);
    } finally {
      setIsLoadingSix(false);
    }
  };

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    handleAPIone();
    handleAPItwo();
    handleAPIthree();
    handleAPIfour();
    handleAPIfive();
    handleAPISix();
  };

  return (
    <>
      <div className="AllAPIsForm">
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <input
              type="text"
              name="brand_name"
              value={inputs.brand_name}
              onChange={handleChange}
              placeholder="Brand Name"
            />
            <input
              type="text"
              name="celebrity_name"
              value={inputs.celebrity_name}
              onChange={handleChange}
              placeholder="Celebrity Name"
            />
          </div>
          <div className="form-row">
            <textarea
              name="collab_details"
              value={inputs.collab_details}
              onChange={handleChange}
              placeholder="Fusion Details"
              autoComplete="off"
            />
          </div>
          <div className="form-row">
            <input
              type="date"
              name="date"
              value={inputs.date || formatDate(new Date())} // Use formatted date as fallback
              onChange={handleChange}
              max={formatDate(new Date())} // Today's date as the max value
            />
            <button type="submit">Submit</button>
          </div>
        </form>
      </div>
      <div className="results">
        <div className="results-section">
          {isLoadingOne && <div className="loading-message">Loading...</div>}
          {errorMessageOne && (
            <div className="error-message">{errorMessageOne}</div>
          )}
          {resultsOne && resultsOne.imageUrls && <h3>API 1 Results</h3>}
          {resultsOne &&
            resultsOne.imageUrls &&
            resultsOne.imageUrls.map((imageUrl, index) => (
              <ResultTile
                key={index}
                imageUrl={imageUrl}
                copy={resultsOne.Copy[index]}
              />
            ))}
        </div>
        <div className="results-section">
          {isLoadingTwo && <div className="loading-message">Loading...</div>}
          {errorMessageTwo && (
            <div className="error-message">{errorMessageTwo}</div>
          )}
          {resultsTwo.geo && (
            <div>
              <h3 className="h4">API 2a - Brand Geo Results</h3>
              <ul>
                {resultsTwo.geo.map((geo, index) => (
                  <li key={index}>
                    {geo.region}: {geo.geo_score}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        <div className="results-section">
          {isLoadingThree && <div className="loading-message">Loading...</div>}
          {errorMessageThree && (
            <div className="error-message">{errorMessageThree}</div>
          )}
          {resultsThree.geo && (
            <div>
              <h3 className="h4">API 2b -Celebrity Geo Results</h3>
              <ul>
                {resultsThree.geo.map((geo, index) => (
                  <li key={index}>
                    {geo.region}: {geo.geo_score}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        <div className="results-section">
          {isLoadingFour && <div className="loading-message">Loading...</div>}
          {errorMessageFour && (
            <div className="error-message">{errorMessageFour}</div>
          )}
          {resultsFour && resultsFour.mentions && (
            <div>
              <h3>API 3 Results</h3>
              <p>
                Mentions: <strong>{resultsFour.mentions}</strong>
              </p>
            </div>
          )}
        </div>
        <div className="results-section">
          {isLoadingFive && <div className="loading-message">Loading...</div>}
          {errorMessageFive && (
            <div className="error-message">{errorMessageFive}</div>
          )}
          {resultsFive && resultsFive.predicted_mention && (
            <div>
              <h3>API 4 Results</h3>
              <p>
                Predicted Mentions:{' '}
                <strong>{resultsFive.predicted_mention}</strong>
              </p>
              <p>
                Predicted Reach: <strong>{resultsFive.predicted_reach}</strong>
              </p>
            </div>
          )}
          {resultsFive.brand_timeseries && (
            <div>
              <h3 className="h4">Brand Timeseries</h3>
              <ul>
                {resultsFive.brand_timeseries.map((ts, index) => (
                  <li key={index}>
                    {ts.date}: {ts.time_score}
                  </li>
                ))}
              </ul>
            </div>
          )}
          {resultsFive.celeb_timeseries && (
            <div>
              <h3 className="h4">Celebrity Timeseries</h3>
              <ul>
                {resultsFive.celeb_timeseries.map((ts, index) => (
                  <li key={index}>
                    {ts.date}: {ts.time_score}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        <div className="results-section">
          {isLoadingSix && <div className="loading-message">Loading...</div>}
          {errorMessageSix && (
            <div className="error-message">{errorMessageSix}</div>
          )}
          {resultsSix && resultsSix.ideas && (
            <div>
              <h3>API 5 Results</h3>
              <ul>
                {resultsSix.ideas.map((idea, index) => (
                  <li key={index}>{idea}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default AllAPIsForm;
